module.exports = "https://img.zhijierongxing.com/saas/img/Payment_icon0.172da5af.png";